.spinnerBlock {
    margin: 100px 0;
    text-align: center;

    .spinnerText {
        margin: 30px 0 0;
    }

    .biLoading {
        --size: 60px;

        display: inline-block;
        position: relative;
        width: var(--size);
        height: var(--size);
        overflow: hidden;

        span {
            position: absolute;
            box-sizing: border-box;
            display: block;
            width: 400%;
            height: 400%;
            border: none;
            border-top: 5px solid;
            border-image-slice: 1;
            border-image-source: linear-gradient(
                to right,
                rgba(255, 255, 255, 0),
                rgba(255, 255, 255, 0) 10%,
                #18b1ff,
                #006bb4 50%,
                rgba(255, 255, 255, 0) 50%,
                rgba(255, 255, 255, 0) 60%,
                #18b1ff,
                #006bb4
            );

            &.t {
                transform: rotate(0deg);
                left: -200%;
                animation: animate-t 2s linear infinite;
            }

            &.r {
                transform: rotate(90deg);
                left: -300%;
                top: -300%;
                animation: animate-r 2s linear infinite;
            }

            &.b {
                transform: rotate(180deg);
                left: -100%;
                top: -300%;
                animation: animate-b 2s linear infinite;
            }

            &.l {
                transform: rotate(270deg);
                top: 0;
                left: 0;
                animation: animate-l 2s linear infinite;
            }
        }
    }
}

@keyframes animate-t {
    0% {
        left: -200%;
    }

    100% {
        left: 0%;
    }
}

@keyframes animate-r {
    0% {
        top: -300%;
    }

    100% {
        top: -100%;
    }
}

@keyframes animate-b {
    0% {
        left: -100%;
    }

    100% {
        left: -300%;
    }
}

@keyframes animate-l {
    0% {
        top: 0%;
    }

    100% {
        top: -200%;
    }
}
